<template>
  <div class="add_banks_tags">
    <v-text-field
      v-model="name"
      label="Название"
      required
    />
    <v-textarea
      v-model="description"
      label="Описание"
    ></v-textarea>
    <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn @click="saveTag" outlined>Добавить ТЕГ</v-btn>
      </v-card-actions>
  </div>
</template>
<script>
export default {
  name: "add_banks_tags",
  components: {},
  data: () => ({
    name: '',
    description: ''
  }),
  props: {},
  methods: {
    saveTag(){
      this.$store.dispatch('AddBanksTag',{name: this.name, description: this.description})
      this.name = ''
      this.description = ''
    },
  },
  created() {},
  mounted() {},
  watch: {},
};
</script>
<style lang="sass" scoped>
</style>
